import { BOTTOM_SHEET_SUBTITLE_ID_SUFFIX, BOTTOM_SHEET_TITLE_ID } from '../constants.js';

var getLabelledAndDescribedBy = function getLabelledAndDescribedBy(id, subtitleId) {
  return {
    labelledBy: id + BOTTOM_SHEET_TITLE_ID,
    describedBy: subtitleId ? id + BOTTOM_SHEET_SUBTITLE_ID_SUFFIX : undefined
  };
};
var useBottomSheetHeader = function useBottomSheetHeader(_ref) {
  var subtitle = _ref.subtitle,
    title = _ref.title,
    id = _ref.id;
  var _getLabelledAndDescri = getLabelledAndDescribedBy(id, subtitle),
    labelledBy = _getLabelledAndDescri.labelledBy,
    describedBy = _getLabelledAndDescri.describedBy;
  return {
    bottomSheetHeaderProps: {
      labelledBy: labelledBy,
      describedBy: describedBy,
      subtitle: subtitle,
      title: title
    }
  };
};

export { getLabelledAndDescribedBy, useBottomSheetHeader };
//# sourceMappingURL=useBottomSheetHeader.js.map
